import { FunctionComponent } from 'react';

import { List } from '@andes/list';
import { RegulatedModal } from 'rgl-transitions-library';

import { HubWordings } from '../../../../../wordings';
import StepItem from '../item';
import { StepsContextProps, useStepsContext } from '../StepsContext';
import type { Step } from '../../../../../../services/types';
import { type PageContextType, usePage } from '../../../../../contexts/PageContext';


type Props = {
  wordings: HubWordings
  stepsPendingWordings: HubWordings
  feedbackStepUrl: string
  animatedCongratsStep?: Step
}

const StepList: FunctionComponent<Props> = (props: Props) => {
  const { wordings, stepsPendingWordings, animatedCongratsStep, feedbackStepUrl } = props;
  const { isMobile } = usePage() as PageContextType;
  const { steps, regulatedStepData } = useStepsContext() as StepsContextProps;

  return (
    <>
      {regulatedStepData && !isMobile && (
        <RegulatedModal
          appFrom="auth-hub-frontend"
          deviceType="desktop"
          content={regulatedStepData.content}
          redirectUrl={regulatedStepData.uri}
        />
      )}
      <List
        id="step-list"
        className="step-list"
        selectable={false}
        srLabel={wordings.title}
      >
        {steps!.map((step) => (
          <StepItem
            key={step.id}
            step={step}
            wordings={wordings}
            stepsPendingWordings={stepsPendingWordings}
            animatedCongratsStep={animatedCongratsStep}
            feedbackStepUrl={feedbackStepUrl}
          />
        ))}
      </List>
    </>
  );
};

export default StepList;
